var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import { jsx } from '@emotion/core';
import { COLORS, BORDER_RADIUS, FONT } from '../../../constants';
import { Spinner } from '../../Spinner';
import { Icon } from '../../Icon';
import { itemStyles } from './item';
import Badge from './badge';
var iconStyles = {
  '.trustpilot-icon': {
    marginLeft: '4px',
    fill: 'inherit',
    width: '8px',
    height: '8px'
  }
};
var activeStyles = {
  background: COLORS.white,
  borderColor: COLORS.blues.primary,
  color: COLORS.blues.primary,
  fill: COLORS.blues.primary,
  boxShadow: 'none',
  outline: 'none'
};
var inactiveStyles = {
  background: COLORS.white,
  border: "1px solid " + COLORS.grays.cardBorder,
  boxShadow: '0 1px 2px 0 rgba(0,0,0,0.08)',
  borderRadius: BORDER_RADIUS.medium,
  color: COLORS.grays.dark,
  fontSize: '14px',
  lineHeight: '20px',
  padding: '5px 12px',
  boxSizing: 'border-box',
  marginBottom: 0,
  display: 'flex',
  alignItems: 'center',
  fill: COLORS.grays.light
};

var baseStyles = __assign(__assign(__assign({
  fontFamily: FONT.family
}, inactiveStyles), iconStyles), {
  '&:hover, &:focus': activeStyles,
  // overwriting the :disabled styling from b2bCoreFramework
  '&:disabled, &:disabled:hover': inactiveStyles
});

var iconButtonStyles = {
  padding: 9,
  '.trustpilot-icon': {
    marginLeft: 0,
    width: 12,
    height: 12
  }
};
export var IconButton = function IconButton(_a) {
  var icon = _a.icon,
      onClick = _a.onClick,
      _b = _a.className,
      className = _b === void 0 ? '' : _b,
      dataTestId = _a.dataTestId;
  return jsx("button", {
    className: className,
    css: [baseStyles, iconButtonStyles],
    onClick: onClick,
    "data-testid": dataTestId
  }, jsx(Icon, {
    content: icon
  }));
};
export var Button = function Button(_a) {
  var _b = _a.count,
      count = _b === void 0 ? 0 : _b,
      _c = _a.loading,
      loading = _c === void 0 ? false : _c,
      _d = _a.active,
      active = _d === void 0 ? loading : _d,
      children = _a.children,
      onClick = _a.onClick,
      _e = _a.icon,
      icon = _e === void 0 ? null : _e,
      _f = _a.iconClassName,
      iconClassName = _f === void 0 ? '' : _f,
      id = _a.id;
  var styles = [baseStyles];
  var onButtonClick = React.useCallback(function () {
    if (!loading) {
      onClick();
    }
  }, [loading, onClick]);
  if (active) styles.push(activeStyles);

  if (loading) {
    return jsx("button", {
      css: styles,
      disabled: loading,
      onClick: onButtonClick
    }, jsx(Spinner, {
      size: 20
    }));
  }

  return jsx("button", {
    "data-testid": "pl-header-filters-button-" + id,
    css: styles,
    disabled: loading,
    onClick: onButtonClick
  }, !loading && jsx("span", null, children), count > 0 && jsx(Badge, null, count), icon && jsx(Icon, {
    className: iconClassName,
    content: icon
  }));
};

var ButtonItem = function ButtonItem(props) {
  return jsx("div", {
    css: itemStyles
  }, jsx(Button, __assign({}, props)));
};

export default ButtonItem;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Header/filters/button.js
// module id = 73
// module chunks = 0